/**
 * Normalize list API responses (legacy array or { data, total, page, limit }).
 */
export function parsePaginatedResponse(body) {
  if (Array.isArray(body)) {
    return { rows: body, total: body.length };
  }
  return {
    rows: body?.data || [],
    total: Number(body?.total) || 0,
  };
}

export function getPaginationDisplay(currentPage, entriesPerPage, totalCount) {
  const totalPages = Math.ceil(totalCount / entriesPerPage) || 1;
  const indexOfFirstEntry = totalCount === 0 ? 0 : (currentPage - 1) * entriesPerPage + 1;
  const indexOfLastEntry = Math.min(currentPage * entriesPerPage, totalCount);
  return { totalPages, indexOfFirstEntry, indexOfLastEntry };
}
